module.exports = "/static/media/discover-card.17742e88.jpg";